import React, { Suspense, lazy } from 'react'
import { useParams, useNavigate } from 'react-router-dom'
import content from '../../content.json'
// import Service from './service'
const Service = lazy(() => import('./service'))

// Simple mapping of slug -> service data. Expand or move to a separate data file as needed.
const SERVICE_DATA = content.service_data

// Dynamic import context for images in Items folder
const imagesContext = require.context('../../Items', false, /\.(png|jpe?g|svg|webp)$/);

const getImage = (imageName) => {
  if (!imageName) return null;
  try {
    return imagesContext(`./${imageName}`);
  } catch (e) {
    console.error(`Image ${imageName} not found in Items folder`);
    return null;
  }
};

export default function ServicePage() {
  const { slug } = useParams()
  const navigate = useNavigate()

  // Create a shallow copy to avoid mutating the original data
  const originalService = SERVICE_DATA[slug]

  if (!originalService) {
    // Simple fallback: redirect back to main services section
    // Or render a 404 page if you prefer
    navigate('/')
    return null
  }

  const service = {
    ...originalService,
    img: getImage(originalService.img) || originalService.img,
    img2: getImage(originalService.img2) || originalService.img2
  }

  return (
    <Suspense fallback={<div>Loading...</div>}>
      <Service service={service} />
    </Suspense>
  )
}
